export const MinorAilmentStep = {
  PreAssessment: 1,
  ClinicalAssessment: 2,
  SignsAndSymptoms: 3,
  Differential: 4,
  Treatment: 5,
  Education: 6,
  Documentation: 7,
};

export const AlertConfirmationTypes = {
  ContinueWithRefer: 1,
  ContinueWithNoReferral: 2,
  OTCConsult: 3,
  EndService: 4
};


export const GetAlertConfirmation = (type) => {
  switch(type) {
    case 1:
      return "Continue Service & Refer";
    case 2:
      return "Continue Service with No Referral";
    case 3:
      return "OTC Consult & Refer";
    case 4:
      return "End Service & Refer";
    default: 
      return "";
  }
};

export const ProvinceAbbreviations = {
  alberta: "AB",
  british_columbia: "BC",
  manitoba: "MB",
  new_brunswick: "NB",
  newfoundland_and_labrador: "NL",
  northwest_territories: "NT",
  nova_scotia: "NS",
  nunavut: "NU",
  ontario: "ON",
  prince_edward_island: "PE",
  quebec: "QC",
  saskatchewan: "SK",
  yukon: "YT",
};
